<template>
  <div>
    <Breadcrumbs
      v-if="showBreadcrumbs"
      :current-folder="currentFolderTitle"
      :current-folder-uuid="currentFolderUuid"
      :ancestors="ancestors"
      :shared-item-mode="sharedItemMode"
    />
    <div class="text-center flex justify-center items-center my-4 border border-grey rounded shadow">
      <div class="w-full mb-12">
        <h1>
          Edit Members:
          <span
            class="font-semibold text-grey-darkest"
            v-html="resourceTitle"
          />
        </h1>

        <!--
                <div class="flex justify-center items-baseline mt-4" v-if="visibilities.length">
                    <div class="input-group">
                        <input type="text" v-model="search" placeholder="Search">
                    </div>
                    <div class="text-xs pl-4">
                        <a href="#" @click.prevent="selectAll">Select All</a>
                        | <a href="#" @click.prevent="selectNone">Select None</a>
                    </div>
                </div>
                -->

        <div class="flex justify-between items-baseline px-8 border-b border-grey w-full">
          <h3
            class="font-bold text-grey-dark"
            v-text="'Groups'"
          />
          <a
            href="#"
            class="btn btn--sm"
            @click.prevent="openSendToMembershipGroupsModal"
            v-text="'Add Groups'"
          />
        </div>
        <ul
          v-if="filteredMembershipGroupVisibilities.length && !loading"
          class="list-reset flex-wrap flex mx-6"
        >
          <li
            v-for="visibility in filteredMembershipGroupVisibilities"
            :key="visibility.uuid"
            class="w-1/5 flex items-top"
          >
            <div class="border rounded w-full mx-4 p-3 border-grey-dark my-2 flex items-center">
              <input
                :id="`group-visibility-${visibility.uuid}`"
                :key="visibility.uuid"
                v-model="selectedVisibilities"
                type="checkbox"
                :name="`group-visibility-${visibility.uuid}`"
                :value="visibility.uuid"
              >
              <label
                :for="`group-visibility-${visibility.uuid}`"
                class="mb-0 w-full text-left"
                v-text="visibility.visibleTo.attributes.title"
              />
            </div>
          </li>
        </ul>
        <div
          v-if="!filteredMembershipGroupVisibilities.length && !loading"
          class="font-extrabold items-stretch m-4 text-3xl text-grey-dark"
          v-text="'No results'"
        />
        <div
          v-else
          class="flex justify-start mx-8 mb-6 items-baseline"
        >
          <button
            type="button"
            class="btn btn--danger mx-2"
            @click.prevent="removeVisibilities"
            v-text="'Remove visibility'"
          />
          <a
            :href="folderDetailsUrl"
            class="text-grey-darker mx-8"
            v-text="'Cancel'"
          />
        </div>
        <div class="flex justify-between items-baseline px-8 border-b border-grey  w-full">
          <h3
            class="font-bold text-grey-dark"
            v-text="'Individual Members'"
          />
          <a
            href="#"
            class="btn btn--sm"
            @click.prevent="openSendToMembershipsModal"
            v-text="'Add Members'"
          />
        </div>
        <ul
          v-if="filteredMembershipVisibilities.length && !loading"
          class="list-reset flex-wrap flex mx-6"
        >
          <li
            v-for="visibility in filteredMembershipVisibilities"
            :key="visibility.uuid"
            class="w-1/5 flex items-top"
          >
            <div class="border rounded w-full mx-4  p-3 border-grey-dark my-2 flex items-center">
              <input
                :id="`membership-visibility-${visibility.uuid}`"
                :key="visibility.uuid"
                v-model="selectedVisibilities"
                type="checkbox"
                :name="`membership-visibility-${visibility.uuid}`"
                :value="visibility.uuid"
              >
              <label
                :for="`membership-visibility-${visibility.uuid}`"
                class="mb-0 w-full text-left"
                v-text="visibility.visibleTo.attributes.full_name"
              />
            </div>
          </li>
        </ul>
        <div
          v-if="!filteredMembershipVisibilities.length && !loading"
          class="font-extrabold items-stretch m-4 text-3xl text-grey-dark"
          v-text="'No results'"
        />
        <div
          v-else
          class="flex justify-start mx-8 mb-8 items-baseline"
        >
          <button
            type="button"
            class="btn btn--danger mx-2"
            @click.prevent="removeVisibilities"
            v-text="'Remove visibility'"
          />
          <a
            :href="folderDetailsUrl"
            class="text-grey-darker mx-8"
            v-text="'Cancel'"
          />
        </div>
      </div>
    </div>
    <SendToMembershipGroupsModal
      :shared-item-mode="sharedItemMode"
      @resourceHasBeenSentToMembershipGroups="fetch"
    />
    <SendToMembershipsModal
      :shared-item-mode="sharedItemMode"
      @resourceHasBeenSentToMemberships="fetch"
    />
  </div>
</template>

<script type="text/babel">
import Breadcrumbs from './FolderBreadcrumbs'
import SendToMembershipGroupsModal from './_modals/SendToMembershipGroupsModal'
import SendToMembershipsModal from './_modals/SendToMembershipsModal'

export default {
  name: 'VisibilityEditor',
  components: {
    Breadcrumbs,
    SendToMembershipGroupsModal,
    SendToMembershipsModal,
  },
  props: {
    sharedItemMode: {
      type: Boolean,
      required: true,
    },
    resourceUuid: {
      type: String,
      required: true,
    },
    resourceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      search: '',
      selectedVisibilities: [],
      resource: {
        _type: null,
        uuid: '',
        attributes: {
          title: '',
        },
        ancestors: {
          data: [],
        },
        visibilities: {
          data: [],
        },
        // Folder is set here in case the resource is a document
        folder: {
          uuid: '',
          ancestors: {
            data: [],
          },
          attributes: {
            title: '',
          },
        },
      },
    }
  },
  computed: {
    fetchUrl() {
      if (this.sharedItemMode) {
        switch (this.resourceType.toLowerCase()) {
          case 'document':
            return `shares/documents/${this.resourceUuid}?include=visibilities`
          case 'folder':
            return `shares/folders/${this.resourceUuid}?include=visibilities,ancestors`
          default:
            throw 'Could not build fetch url'
        }
      }

      switch (this.resourceType.toLowerCase()) {
        case 'folder':
          return `${this.resourceType.toLowerCase()}s/${this.resourceUuid}?include=visibilities,ancestors`
        case 'document':
          return `${this.resourceType.toLowerCase()}s/${this.resourceUuid}?include=folder.ancestors,visibilities`
        default:
          throw 'Invalid resource type'
      }
    },
    removeVisibilitiesUrl() {
      if (this.sharedItemMode) {
        switch (this.resourceType.toLowerCase()) {
          case 'document':
            return `shares/documents/${this.resourceUuid}/visibilities/delete`
          case 'folder':
            return `shares/folders/${this.resourceUuid}/visibilities/delete`
          default:
            throw 'Invalid shared item removal url'
        }
      }

      return `${this.resourceType.toLowerCase()}s/${this.resourceUuid}/visibilities/delete`
    },
    showBreadcrumbs() {
      if (this.sharedItemMode) {
        return this.resourceType.toLowerCase() === 'folder'
      }

      return true
    },
    resourceTitle() {
      return this.resource.attributes.title
    },
    currentFolderTitle() {
      if (!this.sharedItemMode) {
        switch (this.resourceType.toLowerCase()) {
          case 'folder':
            return this.resource.attributes.title
          case 'document':
            return this.resource.folder.attributes.title
        }

        throw 'Could not generate Folder Title'
      }

      return this.resource.attributes.title
    },
    currentFolderUuid() {
      if (!this.sharedItemMode) {
        switch (this.resourceType.toLowerCase()) {
          case 'folder':
            return this.resource.uuid
          case 'document':
            return this.resource.folder.uuid
        }

        throw 'Could not generate Folder Uuid'
      }

      return this.resource.uuid
    },
    folderDetailsUrl() {
      if (!this.sharedItemMode) {
        switch (this.resourceType.toLowerCase()) {
          case 'folder':
            return this.$urlGenerator.active(`documents/folders/${this.resource.uuid}`)
          case 'document':
            return this.$urlGenerator.active(`documents/folders/${this.resource.folder.uuid}`)
        }

        throw 'Could not generate Folder Details URL'
      }

      return ''
    },
    ancestors() {
      if (!this.sharedItemMode) {
        switch (this.resourceType.toLowerCase()) {
          case 'folder':
            return this.resource.ancestors.data
          case 'document':
            return this.resource.folder.ancestors.data
        }

        return []
      }

      return this.resource.ancestors.data
    },
    visibilities() {
      return this.resource.visibilities.data
    },
    membershipGroupVisibilities() {
      return _.filter(this.visibilities, function (visibility) {
        return visibility.visibleTo._type === 'MembershipGroup'
      })
    },
    membershipVisibilities() {
      return _.filter(this.visibilities, function (visibility) {
        return visibility.visibleTo._type === 'Membership'
      })
    },
    filteredMembershipGroupVisibilities() {
      if (this.membershipGroupVisibilities.length) {
        return this.membershipGroupVisibilities.filter((visibility) => {
          const name = visibility.visibleTo.attributes.title.toLowerCase()

          return name.includes(this.search.toLowerCase())
        })
      }

      return []
    },
    filteredMembershipVisibilities() {
      if (this.membershipVisibilities.length) {
        return this.membershipVisibilities.filter((visibility) => {
          const name = `${visibility.visibleTo.attributes.first_name.toLowerCase()} ${visibility.visibleTo.attributes.last_name.toLowerCase()}`

          return name.includes(this.search.toLowerCase())
        })
      }

      return []
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true

      this.$api.active().get(this.fetchUrl).then((response) => {
        this.resource = response.data
        this.loading = false
      })
    },
    removeVisibilities() {
      this.$api.active().post(this.removeVisibilitiesUrl, {
        visibilities: this.selectedVisibilities,
      }).then((response) => {
        this.resetSelectedVisibilities()

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: response.data.message,
        })

        this.fetch()
      })
    },
    openSendToMembershipGroupsModal() {
      this.$store.commit('documentOpenSendToMembershipGroupsModal', this.resource)
    },
    openSendToMembershipsModal() {
      this.$store.commit('documentOpenSendToMembershipsModal', this.resource)
    },
    selectAll() {
      this.selectedVisibilities = _.map(this.visibilities, 'uuid')
    },
    selectNone() {
      this.resetSelectedVisibilities()
    },
    resetSelectedVisibilities() {
      this.selectedVisibilities = []
    },
  },
}
</script>
